var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "EditTable" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "tabel-warp"
        },
        [
          _c(
            "vxe-table",
            {
              ref: "vxeTable",
              attrs: {
                align: "center",
                border: "",
                data: _vm.tabelData,
                "column-config": _vm.columnConfig,
                "row-config": { isHover: true },
                round: "",
                size: "small",
                "tooltip-config": {
                  showAll: true
                },
                stripe: "",
                "edit-config": _vm.editConfig,
                "keep-source": "",
                "edit-rules": _vm.vxeRules,
                height: "100%"
              }
            },
            [
              _c("vxe-column", {
                attrs: {
                  field: "BARCODE",
                  title: "箱号",
                  "min-width": "200",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.BARCODE,
                            callback: function($$v) {
                              _vm.$set(row, "BARCODE", $$v)
                            },
                            expression: "row.BARCODE"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PART_NO",
                  title: "物料代码",
                  "min-width": "160",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PART_NO,
                            callback: function($$v) {
                              _vm.$set(row, "PART_NO", $$v)
                            },
                            expression: "row.PART_NO"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PART_NAME",
                  title: "物料名称",
                  "min-width": "200",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PART_NAME,
                            callback: function($$v) {
                              _vm.$set(row, "PART_NAME", $$v)
                            },
                            expression: "row.PART_NAME"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "QTY",
                  title: "本箱数量",
                  "min-width": "120",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PO_REMAINING_QTY,
                            callback: function($$v) {
                              _vm.$set(row, "PO_REMAINING_QTY", $$v)
                            },
                            expression: "row.PO_REMAINING_QTY"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PART_DESCR",
                  title: "规格描述",
                  "min-width": "180",
                  "show-overflow": "ellipsis",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PART_DESCR,
                            callback: function($$v) {
                              _vm.$set(row, "PART_DESCR", $$v)
                            },
                            expression: "row.PART_DESCR"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "TOTAL_QTY",
                  title: "本批数量",
                  "min-width": "150",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "number", disabled: false },
                          model: {
                            value: row.SPQ,
                            callback: function($$v) {
                              _vm.$set(row, "SPQ", $$v)
                            },
                            expression: "row.SPQ"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PACKING_QTY",
                  title: "装箱单位数量",
                  "min-width": "120",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "number", disabled: true },
                          model: {
                            value: row.SCMCreateOrder_QTY,
                            callback: function($$v) {
                              _vm.$set(row, "SCMCreateOrder_QTY", $$v)
                            },
                            expression: "row.SCMCreateOrder_QTY"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c("changeOrderDialog", {
        ref: "changeOrderDialog",
        attrs: { isShowChangeOrderDialog: _vm.isShowChangeOrderDialog },
        on: {
          closeChangeOrderDialog: _vm.closeChangeOrderDialog,
          cbDialogSubmit: _vm.cbDialogSubmit
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }